<template>
  <section class="bg-muted/20 py-20 md:py-28">
    <div class="mx-auto max-w-6xl px-4 md:px-6">
      <div class="grid gap-12 lg:grid-cols-2 lg:items-center">

        <!-- Visual -->
        <div class="flex justify-center">
          <div class="relative flex h-64 w-64 items-center justify-center rounded-3xl bg-foreground shadow-xl md:h-80 md:w-80">
            <Icon name="tabler:robot" size="120" class="text-background/80" />
            <div class="absolute -top-4 -right-4 flex items-center gap-2 rounded-full border border-border/60 bg-white px-4 py-2 text-sm font-semibold text-foreground shadow-sm">
              <Icon name="tabler:bolt" size="14" class="text-foreground" />
              {{ $ts('aiAssistant.tags.instantHelp') }}
            </div>
            <div class="absolute -bottom-4 -left-4 flex items-center gap-2 rounded-full border border-border/60 bg-white px-4 py-2 text-sm font-semibold text-foreground shadow-sm">
              <Icon name="tabler:clock" size="14" class="text-muted-foreground" />
              {{ $ts('aiAssistant.tags.available247') }}
            </div>
          </div>
        </div>

        <!-- Copy -->
        <div>
          <span class="mb-4 inline-flex items-center gap-1.5 rounded-full border border-border/60 bg-white px-3 py-1 text-xs font-semibold uppercase tracking-widest text-muted-foreground">
            <Icon name="tabler:sparkles" size="12" />
            {{ $ts('aiAssistant.badge') }}
          </span>
          <h2 class="mt-4 text-4xl font-bold leading-[1.05] tracking-tight text-foreground md:text-5xl">
            {{ $ts('aiAssistant.title') }}
          </h2>
          <p class="mt-4 text-lg leading-relaxed text-muted-foreground">
            {{ $ts('aiAssistant.description') }}
          </p>

          <ul class="mt-8 space-y-3">
            <li
              v-for="(feature, idx) in features"
              :key="idx"
              class="flex items-center gap-3 text-sm font-medium text-foreground"
            >
              <div class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-foreground">
                <Icon name="tabler:check" size="12" class="text-background" />
              </div>
              {{ feature }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '#imports';

const { $ts } = useI18n();

const features = computed(() => [
  $ts('aiAssistant.features.0'),
  $ts('aiAssistant.features.1'),
  $ts('aiAssistant.features.2'),
  $ts('aiAssistant.features.3'),
]);
</script>
